import React, { useEffect, useRef } from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const CodeInput = (props) => {
    const length = props.length ?? 6;
    const refs = useRef([]);
    useEffect(() => {
        if (props.autoFocus) {
            refs.current[0]?.focus();
        }
    }, [props.autoFocus]);
    const setValue = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, length);
        props.onChange(digits);
        refs.current[Math.min(digits.length, length - 1)]?.focus();
        if (digits.length === length) {
            props.onComplete?.(digits);
        }
    };
    return (React.createElement(Boxes, { role: "group", "aria-label": props.label }, Array.from({ length }, (_, index) => (React.createElement(Box, { key: index, ref: (el) => {
            refs.current[index] = el;
        }, type: "text", inputMode: "numeric", pattern: "[0-9]*", autoComplete: index === 0 ? 'one-time-code' : 'off', maxLength: length, "aria-label": `${props.label ?? ''} ${index + 1}/${length}`.trim(), value: props.value[index] ?? '', onFocus: (e) => e.target.select(), onChange: (e) => {
            const typed = e.target.value.replace(/\D/g, '');
            if (typed.length > 1) {
                // A paste or an autofill of the whole code into one box.
                setValue(typed);
                return;
            }
            setValue(props.value.slice(0, index) +
                typed +
                props.value.slice(index + 1));
        }, onKeyDown: (e) => {
            if (e.key === 'Backspace' && (props.value[index] ?? '') === '') {
                e.preventDefault();
                setValue(props.value.slice(0, Math.max(0, index - 1)));
            }
            else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                refs.current[index - 1]?.focus();
            }
            else if (e.key === 'ArrowRight') {
                e.preventDefault();
                refs.current[index + 1]?.focus();
            }
        }, onPaste: (e) => {
            e.preventDefault();
            setValue(e.clipboardData.getData('text'));
        } })))));
};
const Boxes = styled.div `
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 20px;

  /* A visual pause between the two halves of the code */
  input:nth-child(3) {
    margin-right: 8px;
  }
`;
const Box = styled.input `
  width: 44px;
  height: 54px;
  padding: 0;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: ${THEME.COLOR_PRIMARY};
  background-color: ${THEME.COLOR_SECONDARY};
  border: 1px solid ${THEME.BORDER_STRONG};
  border-radius: 3px;
  outline: none;
  caret-color: ${THEME.COLOR_ACCENT};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    border-color: ${THEME.COLOR_ACCENT};
    box-shadow: 0 0 0 3px ${THEME.ACCENT_SURFACE_STRONG};
  }
`;
export default CodeInput;
//# sourceMappingURL=CodeInput.js.map